<template>
  <d2-container>
      <el-form
        :model="form"
        ref="form"
        size="small"
        label-width="300px"
      >
        <el-form-item
                prop="platform_scale"
                label="平台返佣比例（%）"
                :rules="[{ required: true, message: '不能为空且为数字'}]"
        >
          <el-input  @keyup.native="changeAmount"  v-model="form.platform_scale"></el-input>
        </el-form-item>
        <el-form-item
                      prop="one_agent_scale"
                      label="一级代理返佣比例（%）"
                      :rules="[{ required: true, message: '不能为空且为数字'}]"
        >
          <el-input @keyup.native="changeAmount2"  v-model="form.one_agent_scale"></el-input>
        </el-form-item>
        <el-form-item
                prop="two_agent_scale"
                label="二级代理返佣比例（%）"
                :rules="[{ required: true, message: '不能为空且为数字'}]"
        >
          <el-input @keyup.native="changeAmount3"  v-model="form.two_agent_scale"></el-input>
        </el-form-item>
        <el-form-item
                prop="three_agent_scale"
                label="三级代理返佣比例（%）"
                :rules="[{ required: true, message: '不能为空且为数字'}]"
        >
          <el-input @keyup.native="changeAmount4"  v-model="form.three_agent_scale"></el-input>
        </el-form-item>
        <el-form-item
                prop="consume_agent_scale"
                label="用户消费返佣比例（%）"
                :rules="[{ required: true, message: '不能为空且为数字'}]"
        >
          <el-input @keyup.native="changeAmount5" v-model="form.consume_agent_scale"></el-input>
        </el-form-item>
        <el-form-item
                prop="shop_locking"
                label="推荐用户注册返佣比例（%）"
                :rules="[{ required: true, message: '不能为空且为数字'}]"
        >
          <el-input @keyup.native="changeAmount7" v-model="form.shop_locking"></el-input>
        </el-form-item>
        <el-form-item
                prop="user_recom_scale"
                label="消费商家返佣比例"
                :rules="[{ required: true, message: '不能为空且为数字'}]"
        >
          <el-input @keyup.native="changeAmount6" v-model="form.user_recom_scale"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
                  type="primary"
                  :loading="loading"
                  @click="saveUser"
          >保存</el-button>
        </el-form-item>
      </el-form>

  </d2-container>
</template>
<script>
import * as agentService from '@/api/sys/agent'
import util from '@/libs/util.js'
export default {
  name: 'ShopsPage',
  components: { },
  data () {
    return {
      loading: false,
      form: {
        userCode: ''
      }
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    changeAmount () {
      this.form.platform_scale = this.form.platform_scale.replace(/[^\d.]/g, '')
    },
    changeAmount2 () {
      this.form.one_agent_scale = this.form.one_agent_scale.replace(/[^\d.]/g, '')
    },
    changeAmount3 () {
      this.form.two_agent_scale = this.form.two_agent_scale.replace(/[^\d.]/g, '')
    },
    changeAmount4 () {
      this.form.three_agent_scale = this.form.three_agent_scale.replace(/[^\d.]/g, '')
    },
    changeAmount5 () {
      this.form.consume_agent_scale = this.form.consume_agent_scale.replace(/[^\d.]/g, '')
    },
    changeAmount6 () {
      this.form.user_recom_scale = this.form.user_recom_scale.replace(/[^\d.]/g, '')
    },
    changeAmount7 () {
      this.form.shop_locking = this.form.shop_locking.replace(/[^\d.]/g, '')
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          /**  if(this.form.user_recom_scale<70){
                      this.form.user_recom_scale ="";
                     return false;
                  }**/

          this.loading = true
          agentService.saveRakeback({ ...this.form, xt_id: util.cookies.get('xt_id'), agentid: util.cookies.get('agentid') })
            .then(data => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    getTableData () {
      var formData4 = new FormData() // 声明一个FormData对象
      formData4.append('xt_id', util.cookies.get('xt_id'))
      agentService.getRakebackXq(formData4).then(data => {
        if (data != null && data != '') {
          let form = {}

          form.platform_scale = data.platform_scale
          form.one_agent_scale = data.one_agent_scale
          form.two_agent_scale = data.two_agent_scale
          form.three_agent_scale = data.three_agent_scale
          form.consume_agent_scale = data.consume_agent_scale
          form.user_recom_scale = data.user_recom_scale
          form.shop_locking = data.shop_locking

          this.form = form
        }
      })
    }

  }
}
</script>
